export default __webpack_public_path__ + "locales/hy-AM/Ldap.json?hash=cd1183df7049822b5d2e09c8a9849ada";